<template>
  <div class="d-flex align-items-start gap-2 w-100">
    <i v-if="participationStatus === false && show_icons === true" class="fa-light fa-square-arrow-right fs-4 text-primary mt-1"></i>
    <i v-if="participationStatus === true && show_icons === true" class="fa-solid fa-circle-check fs-4 text-primary mt-1" ></i>
    <div class="d-flex flex-column flex-grow-1">
      <div class="w-100" v-bind:class="[ hasUserClassesButtonContainer ? this.classes_button_container : 'd-flex gap-2 justify-content-between']">
        <a v-if="participationStatus === false" v-on:click="toggleParticipation" v-bind:class="[ hasUserClassesButton ? this.classes_button : 'btn btn-primary flex-fill', 'participate', isSubmitting ? 'disabled' : '']" :aria-disabled="isSubmitting ? 'true' : 'false'" href="#" role="button">
          <i v-if="isSubmitting" class="fa-solid fa-spinner fa-spin me-1"></i>
          {{ join_label }} {{ this.participation_type_text }}
        </a>
        <p v-if="participationStatus" class="mb-0">
          <span v-if="zoomRegistrationStatus === 'pending'" class="">
            {{ registration_in_progress_label }}
          </span>
          <span v-else-if="zoomRegistrationStatus === 'error'" class="text-danger">
            <i class="fa-solid fa-triangle-exclamation pe-1"></i>{{ registration_error_label }}
          </span>
          <span v-else>
            <i v-if="isSubmitting" class="fa-solid fa-spinner fa-spin text-primary pe-1"></i>
            <i v-else-if="show_icons === false" class="fa-solid fa-circle-check text-primary pe-1"></i>
            {{ joined_label }} {{ this.participation_type_text }}.
          </span>
          <span class="d-inline-block">
            <a v-on:click="toggleParticipation" v-bind:class="[ 'participate', isSubmitting ? 'disabled' : '' ]" :aria-disabled="isSubmitting ? 'true' : 'false'" href="#" role="button">{{ leave_label }} {{ this.participation_type_text }}</a>
          </span>
        </p>



      </div>
      <p v-if="participationStatus === false && instruction_text" class="mt-2 mb-0 small text-muted">{{ instruction_text }}</p>
      <p v-if="requestError" class="mt-2 mb-0 small text-danger">{{ registration_error_label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
      return {
        hasUserClassesButton: false,
        hasUserClassesButtonContainer: false,
        participationStatus: false,
        zoomRegistrationStatus: null,
        requestError: false,
        isSubmitting: false,
      };
  },

  methods: {
    toggleParticipation: function(e) {
      e.preventDefault();
      if (this.isSubmitting) {
        return;
      }

      this.requestError = false;
      this.isSubmitting = true;

      axios.post("/toggle_event_particpation", {
        event_id: this.id,
        participation_type: this.participation_type,
      })
      .then((response) => {
        if (!response || response.status !== 200) {
          this.requestError = true;
          return;
        }

        const data = response.data;
        const participationStatus = data && data.participation_status ? data.participation_status : data;
        const zoomRegistrationStatus = data && data.zoom_registration_status ? data.zoom_registration_status : null;

        if (participationStatus === 'participation_added') {
          this.participationStatus = true;
          this.zoomRegistrationStatus = zoomRegistrationStatus;
        } else if (participationStatus === 'participation_removed') {
          window.location.reload();
        } else {
          this.requestError = true;
        }
      })
      .catch(() => {
        this.requestError = true;
      })
      .finally(() => {
        this.isSubmitting = false;
      });
    }
  },

  props: [
    'classes_button',
    'classes_button_container',
    'id',
    'participation_type',
    'participation_type_text',
    'participation_initial',
    'show_icons',
    'join_label',
    'joined_label',
    'leave_label',
    'instruction_text',
    'zoom_registration_status',
    'registration_in_progress_label',
    'registration_error_label'
  ],

  created() {
    this.participationStatus = this.participation_initial;
    this.zoomRegistrationStatus = this.zoom_registration_status || null;

    this.hasUserClassesButton  = false;
    if ( this.classes_button !== undefined ) {
      this.hasUserClassesButton  = true;
    }

    this.hasUserClassesButtonContainer  = false;
    if ( this.classes_button_container !== undefined ) {
      this.hasUserClassesButtonContainer  = true;
    }
  }
}
</script>
